<script setup lang="ts">
const route = useRoute();
const currentRouteName = computed(() => String(route.name ?? ''));

const showB2bMenu = computed(() => currentRouteName.value.startsWith('company-post-job___'));

const { attachLoggedUser } = useIntercomHelpers();
const { status } = useAuth();

watchEffect(() => {
  if(status.value === 'authenticated') {
    attachLoggedUser();
  }
});

</script>
<template>
  <Menu></Menu>
  <slot />
  <Footer :b2b_footer="showB2bMenu"></Footer>
</template>
